import React, { FC } from 'react';
import Truncate from 'react-truncate';
import ImgixWrapper from '@common/components/ImgixWrapper';
import { Link } from 'shared-routing';
import { DiscountBanner, FromPrice } from '../Price';
import { VouchersGridProps } from './VouchersGrid.types';
import {
  ITEM_MARGIN,
  Voucher,
  VouchersGridWrapper,
  ImagePlaceholder,
  VoucherName,
  ImageWrapper,
} from './VouchersGrid.styles';

/**
 * @deprecated Use list/listitem
 */
export const VouchersGrid: FC<VouchersGridProps> = ({ items = [], columns = 4, route }) => {
  const imageAspectRatio = 2 / 3;
  const initialWidth = 1440 / columns - 2 * ITEM_MARGIN;
  const initialHeight = Math.floor(initialWidth * imageAspectRatio);

  return (
    <VouchersGridWrapper>
      {items.map((item) => (
        <Voucher columns={columns} key={item.id}>
          <Link route={route} params={{ id: String(item.id) }}>
            {(item.imageGallery || []).length ? (
              <ImageWrapper>
                <DiscountBanner discount={item.discount} />
                <ImgixWrapper
                  src={item.imageGallery?.[0]?.url}
                  width={initialWidth}
                  height={initialHeight}
                  sizes="auto"
                  imgixParams={{
                    ar: '2:3',
                  }}
                  alt={item.name}
                />
              </ImageWrapper>
            ) : (
              <ImagePlaceholder ratio={imageAspectRatio} />
            )}
            <VoucherName>
              <Truncate trimWhitespace lines={2}>
                {item.name}
              </Truncate>
            </VoucherName>
            <FromPrice price={item.price} discount={item.discount} />
          </Link>
        </Voucher>
      ))}
    </VouchersGridWrapper>
  );
};
